import type { StorefrontProduct } from "../types/storefront";
import { mockCategories } from "./categories";

const descriptors = [
  "Classic",
  "Everyday",
  "Premium",
  "Family",
  "Fresh",
  "Original",
  "Select",
  "Signature"
];
const forms = ["Pack", "Bottle", "Box", "Bundle", "Regular", "Large"];
const brands = ["Naya", "Meyar", "Karavan", "Harvest", "Daily", "Nourish"];
const imageMap = [
  "grc.webp",
  "bev.webp",
  "dry.webp",
  "bis.webp",
  "per.webp",
  "cln.webp",
  "brk.webp",
  "tea.webp",
  "cos.webp",
  "kit.webp",
  "snk.webp",
  "hlt.webp"
];

export const mockProducts: StorefrontProduct[] = ["meyar", "freshmart", "royalbakery", "urbanstyle"].flatMap(
  (tenantSlug, tenantIndex) => {
    const categories = mockCategories.filter((category) => category.tenantSlug === tenantSlug);
    const count = tenantSlug === "royalbakery" || tenantSlug === "urbanstyle" ? 30 : 54;
    return Array.from({ length: count }, (_, index) => {
      const category = categories[index % categories.length];
      const base = 140 + ((index * 83 + tenantIndex * 71) % 1850);
      const discounted = index % 5 === 0;
      const stockStatus = index % 19 === 0 ? "out_of_stock" : index % 8 === 0 ? "low_stock" : "in_stock";
      const name = `${descriptors[index % descriptors.length]} ${category.name} ${forms[index % forms.length]}`;
      const primaryImage = `/catalog/${imageMap[(index + tenantIndex * 2) % imageMap.length]}`;
      return {
        id: `${tenantSlug}-product-${index + 1}`,
        tenantId: `${tenantSlug}-tenant`,
        tenantSlug,
        categoryId: category.id,
        branchIds: [`${tenantSlug}-branch-1`, ...(index % 4 === 0 ? [] : [`${tenantSlug}-branch-2`])],
        name,
        websiteName: index % 7 === 0 ? `${name} Special` : undefined,
        slug: `${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${index + 1}`,
        shortDescription: `A dependable ${category.name.toLowerCase()} choice for everyday use.`,
        description: `${name} is selected for consistent quality and practical everyday value. Carefully packed and available from participating branches.`,
        price: base,
        websitePrice: discounted ? base - Math.round(base * 0.12) : undefined,
        compareAtPrice: discounted ? base : undefined,
        images: index % 17 === 0 ? [] : index % 9 === 0 ? [primaryImage, category.image ?? primaryImage] : [primaryImage],
        thumbnail: primaryImage,
        unit: index % 3 === 0 ? "1 kg" : index % 3 === 1 ? "500 g" : "1 pc",
        brand: brands[index % brands.length],
        showOnWebsite: true,
        isActive: true,
        isArchived: false,
        websiteStatus: "published",
        isFeatured: index < 10 || index % 13 === 0,
        availableForDelivery: index % 11 !== 0,
        availableForPickup: index % 10 !== 0,
        stockStatus,
        availableQuantity: stockStatus === "out_of_stock" ? 0 : stockStatus === "low_stock" ? 4 : 25 + (index % 40),
        minimumOrderQuantity: index % 14 === 0 ? 2 : 1,
        maximumOrderQuantity: index % 12 === 0 ? 6 : 20,
        createdAt: new Date(2026, 0, (index % 28) + 1).toISOString()
      };
    });
  }
);
